export const categories = [
  {
    id: 'marriage-management',
    name: '婚姻经营',
    slug: 'marriage-management',
    description: '学习如何经营一段健康美满的婚姻关系，让爱情在岁月中愈加醇厚。',
    icon: 'ri-heart-line',
    color: 'primary',
  },
  {
    id: 'couple-communication',
    name: '夫妻沟通',
    slug: 'couple-communication',
    description: '掌握高效的沟通技巧，化解矛盾、增进理解，让每一次对话都成为感情的养分。',
    icon: 'ri-chat-3-line',
    color: 'accent',
  },
  {
    id: 'family-life',
    name: '家庭生活',
    slug: 'family-life',
    description: '从家务分工到理财规划，从婆媳相处到育儿准备，构建温馨有序的家庭日常。',
    icon: 'ri-home-heart-line',
    color: 'secondary',
  },
  {
    id: 'self-growth',
    name: '自我成长',
    slug: 'self-growth',
    description: '婚后不忘自我提升，保持独立人格与持续学习，成为更好的自己。',
    icon: 'ri-plant-line',
    color: 'primary',
  },
  {
    id: 'newlywed-guide',
    name: '新婚指南',
    slug: 'newlywed-guide',
    description: '从婚礼之后的第一步开始，手把手带你走过新婚磨合期，顺利过渡到幸福的婚姻生活。',
    icon: 'ri-guide-line',
    color: 'accent',
  },
];

export const getCategoryBySlug = (slug: string) => categories.find((c) => c.slug === slug);

export const getCategoryName = (slug: string) => {
  const cat = getCategoryBySlug(slug);
  return cat ? cat.name : slug;
};